<template>
  <el-dialog title :visible.sync="elVisible" :close-on-press-escape="false" :close-on-click-modal="false" width="438px" @close="closeVisible(false)" class="dia_login">
    <div class="header_box flex" v-if="login_Type != 'wx'">
      <div class="item com_link" :class="login_Type=='mobile'?'active':''" @click="goMobileLogin">快捷登录</div>
      <div class="bor"></div>
      <div class="item com_link" :class="login_Type=='pwd'?'active':''" @click="goPwdLogin">账户登录</div>
    </div>
    <!-- 密码登录 -->
    <div class="pwd_login" v-show="login_Type=='pwd'">
      <el-form ref="form" :model="dataLogin" :rules="rules" label-width="0px" label-position="left">
        <el-form-item prop="userAccount">
          <el-input v-model.trim="dataLogin.userAccount" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item prop="userPwd">
          <el-input v-model.trim="dataLogin.userPwd" show-password placeholder="请输入密码" @keyup.enter.native="login"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary btn" @click="login">登录</el-button>
          <div class="forget_pwd">
            <a class="item" href="/retrievePwd" target="_self">忘记密码</a>
          </div>
        </el-form-item>
      </el-form>
      <div class="other_btn">
        <div class="btn_item com_link" @click="goWXLogin">
          <i class="btn_wx iconfont icon-3-copy" />
        </div>
      </div>
    </div>
    <!-- 短信登录 -->
    <div class="msg_login" v-show="login_Type=='mobile'">
      <el-form ref="formMobile" :model="mobileLogin" :rules="rules" label-width="0px" label-position="left">
        <el-form-item prop="mobile">
          <el-input v-model="mobileLogin.mobile" placeholder="请输入手机号码"></el-input>
        </el-form-item>
        <el-form-item class="phone_code" prop="verCode">
          <el-input v-model="mobileLogin.verCode" placeholder="请输入验证码"></el-input>
          <el-button @click="msgSendVerCode" :disabled="downTimeMsg>0" type="primary btn_yel bor_rad0">{{downTimeMsg>0?downTimeMsg+'秒后重发':'发送验证码'}}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary btn" @click="loginByMobile">登录</el-button>
        </el-form-item>
      </el-form>
      <div class="other_btn">
        <div class="btn_item com_link" @click="goWXLogin">
          <i class="btn_wx iconfont icon-3-copy" />
        </div>
      </div>
    </div>
    <!-- 微信登录 -->
    <div class="wx_login" v-show="login_Type=='wx'">
      <div class="qrcode" id="qrcode"></div>
      <div class="other_btn">
        <div class="btn_item com_link" @click="goMobileLogin">
          <i class="btn_shouji iconfont icon-shoujidenglu" />
        </div>
        <div class="btn_item com_link" @click="goPwdLogin">
          <i class="btn_pwd iconfont icon-denglu-zhanghudenglu" />
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {
  LoginByUsername,
  LoginByMobile,
  GetLoginVerCode,
  GetWxWebSiteQrInfo,
} from "@/pages/page1/api/modules/login";
import { checkMobile, checkVerCode } from "@/pages/publicUtils/validate";
import { setLogin } from "@/pages/publicUtils/setLogin";
export default {
  name: "dialogLogin",
  data() {
    return {
      dataLogin: {
        userAccount: "",
        userPwd: "",
        clientType: 0, //pc=0 小程序=1 h5=5 pc_shop=6
        loginType: 0, //平台_商家_C端 = 0,平台_商家 = 1,商家 = 2 C端 = 3,
      },
      mobileLogin: {
        mobile: "",
        verCode: "",
        clientType: 0, //pc=0 小程序=1 h5=5 pc_shop=6
        loginType: 0,
      },
      downTimeMsg: 0,
      rules: {
        userAccount: [{ required: true, message: "必填", trigger: "blur" }],
        userPwd: [{ required: true, message: "必填", trigger: "blur" }],
        mobile: [{ validator: checkMobile, trigger: "blur" }],
        verCode: [{ validator: checkVerCode, trigger: "blur" }],
      },
      elVisible: false,
      login_Type: "pwd",
    };
  },
  mounted() {},
  methods: {
    closeVisible(isLogin) {
      this.$refs.form.resetFields();
      this.$refs.formMobile.resetFields();
      this.login_Type = "pwd";
      this.$emit("updateLogin", isLogin);
    },
    login() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          LoginByUsername(this.dataLogin).then((res) => {
            // console.log("登录返回结果", res);
            this.loginRes(res);
          });
        } else {
          return false;
        }
      });
    },
    loginByMobile() {
      this.$refs.formMobile.validate((valid) => {
        if (valid) {
          LoginByMobile(this.mobileLogin).then((res) => {
            // console.log("登录返回结果", res);
            this.loginRes(res);
          });
        } else {
          return false;
        }
      });
    },
    msgSendVerCode() {
      this.$refs.formMobile.validateField("mobile", (err) => {
        if (!err) {
          GetLoginVerCode({ mobile: this.mobileLogin.mobile }).then((res) => {
            // console.log("获取到的验证码", res);
            this.mobileLogin.verCode = res.data[0].verCode;
            this.downTimeMsg = 60;
            let aTime = setInterval(() => {
              this.downTimeMsg -= 1;
              // console.log(this.downTimeMsg);
              if (this.downTimeMsg <= 0) {
                clearInterval(aTime);
              }
            }, 1000);
          });
        }
      });
    },
    goPwdLogin() {
      this.login_Type = "pwd";
      this.$refs.formMobile.resetFields();
    },
    goMobileLogin() {
      this.login_Type = "mobile";
      this.$refs.form.resetFields();
    },
    //微信登录
    goWXLogin() {
      this.login_Type = "wx";
      this.$refs.form.resetFields();
      this.$refs.formMobile.resetFields();
      GetWxWebSiteQrInfo().then((res) => {
        // console.log("获取微信二维码参数",res);
        let data = res.data[0];
        this.createQR(data.appId, data.scope, data.state, this.$route.fullPath);
      });
    },
    createQR(appid, scope, state, redirect) {
      let url =
        process.env.NODE_ENV === "development"
          ? "http://www.duobihouse.com/wxLogin?redirect=" + redirect
          : process.env.VUE_APP_BASE_URL + "/wxLogin?redirect=" + redirect;
      let obj = new WxLogin({
        self_redirect: true,
        id: "qrcode",
        appid,
        scope,
        state,
        redirect_uri: url,
        style: "black",
      });
    },
    loginRes(res) {
      setLogin(res.data[0]).then(() => {
        this.closeVisible(true);
        this.$message.success("登录成功");
      });
    },
  },
};
</script>

<style lang="less" scoped>
.dia_login {
  /deep/ .el-dialog {
    min-height: 470px;
    box-sizing: border-box;
    .el-dialog__body {
      padding: 0 40px;
      font-size: 16px;
      color: #1a1a1a;
      .other_btn {
        display: flex;
        justify-content: space-around;
        padding-bottom: 30px;
        .btn_item {
          cursor: pointer;
        }
        .btn_shouji {
          color: rgb(234, 107, 101);
          font-size: 38px;
        }
        .btn_wx {
          color: rgb(42, 165, 21);
          font-size: 38px;
        }
        .btn_pwd {
          color: rgb(40, 153, 251);
          font-size: 38px;
        }
      }
      .header_box {
        padding: 0 40px;
        margin-top: 58px;
        margin-bottom: 24px;
        height: 20px;
        line-height: 20px;
        font-weight: bold;
        .item {
          width: 50%;
          text-align: center;
        }
        .bor {
          width: 1px;
          height: 20px;
          background: rgba(26, 26, 26, 1);
          opacity: 0.2;
        }
        .active {
          color: @themeColor;
        }
      }
      .wx_login {
        .qrcode {
          display: flex;
          justify-content: center;
        }
      }
      .pwd_login {
        padding: 0 40px;
      }
      .msg_login {
        padding: 0 40px;
      }
      .el-form {
        .el-form-item {
          margin-bottom: 30px;
          .el-form-item__content {
            .btn {
              width: 100%;
              border-radius: 0px;
            }
            .forget_pwd {
              font-size: 16px;
              font-weight: 500;
              display: flex;
              justify-content: space-between;
              .item {
                display: inline-block;
                color: rgba(26, 26, 26, 1);
              }
            }
          }
        }
        .phone_code {
          .el-form-item__content {
            display: flex;
            justify-content: space-between;
            .el-input {
              width: calc(100% - 88px);
            }
            .btn_yel {
              //   position: absolute;
              //   top: 0px;
              //   right: -128px;
              width: 90px;
              height: 40px;
              line-height: 40px;
              padding: 0 10px;
            }
          }
        }
      }
    }
  }
}
</style>